/**
 * @generated SignedSource<<0d5675471bc09b7ad426cc73d9a915ac>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type reporterRole_personalSettingsPreferenceFields_NotifyWhenRoleIsReporter$data = {
  readonly id: string;
  readonly notifyWhenRoleReporterEnabled: boolean | null | undefined;
  readonly " $fragmentType": "reporterRole_personalSettingsPreferenceFields_NotifyWhenRoleIsReporter";
};
export type reporterRole_personalSettingsPreferenceFields_NotifyWhenRoleIsReporter$key = {
  readonly " $data"?: reporterRole_personalSettingsPreferenceFields_NotifyWhenRoleIsReporter$data;
  readonly " $fragmentSpreads": FragmentRefs<"reporterRole_personalSettingsPreferenceFields_NotifyWhenRoleIsReporter">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "reporterRole_personalSettingsPreferenceFields_NotifyWhenRoleIsReporter",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    },
    {
      "kind": "ScalarField",
      "name": "notifyWhenRoleReporterEnabled"
    }
  ],
  "type": "JiraNotificationOptions"
};

(node as any).hash = "4b74d988a38dc868c149c718ee77d4a1";

export default node;
